import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import { breakpoints } from '../../constants'
import { fontFamilyOpenSans, fontSize3XSmall, fontWeightRegular, grayDark40, grayLight30, white } from '../../constants/principles'
import useHealthCheck from '../../hooks/useHealthCheck'
import useStatesStateData from '../../hooks/useStatesStateData'
import { BrowserUtils } from '../../utils/siteUtils'
import { FlexDiv } from '../generic/Basics'
import MaintenancePage from '../maintenance/Maintenance'
import CarInfo from './CarInfo'
import CarSection from './CarSection'
import FAQ from './FAQ'
import HeaderCopy from './HeaderCopy'
import HowItWorks from './HowItWorks'
import InactiveDealer from './InactiveDealer'
import Style from './LandingTabs/StyleMileage'
import LegalText from './LegalText'
import MobileLegalText from './MobileLegalText'
import VehicleInfoTabs from './VehicleInfoTabs'
import LandingWebComponentWrapper from './LandingWebComponentWrapper'
import LoadingSpinner from './LoadingSpinner'
import { checkIneligibleYear } from '../../utils/vehicleUtils'
import { LandingType } from '../../utils/landingUtils'

export default props => {
  const { globalState, updateGlobalState, year, make, model, trim, eligibility, experienceState, yearParam, makeQuery, modelQuery, urlState, isLinksPage, usingLandingWebComponent, health } = props
  const {
    dealerName,
    dealerPhone,
    dealerId,
    isAssigned,
    isCombinedOffer: isCombined,
    isInactiveDealer,
    experience,
    showVechileImageOnLandingPage,
    isAdmin,
    isCobrand,
    isDigitalRetail,
    isCobrandDR,
    isUIOffForDR,
    dealerIsDirectToKBB,
    dealerIsDirectToKBBv2,
    offerCode,
    optimizelyData,
    landingTypeFromUrl,
    isRequireVinPlate
  } = experienceState

  const [backToVin, setBackToVin] = useState(false)
  const states = useStatesStateData()
  const underMaintenance = useHealthCheck({ reuse: true, landingContextHealth: health })
  const isDesktop = BrowserUtils.isDesktop()
  const activeTab = globalState.activeTab || 'VIN'
  const onClickTab = activeTab => updateGlobalState({ activeTab })
  const showMakeModelTab = isAdmin || ((isAssigned || isCobrand || isDigitalRetail) && !dealerIsDirectToKBB && !dealerIsDirectToKBBv2) // Unassigned kbb and atc should not see makemodel tab
  const isIneligibleYear = checkIneligibleYear(yearParam)
  const isIneligible = (eligibility && !eligibility.isEligible) || isIneligibleYear
  const kbbUrl = globalState && globalState.environment && globalState.environment.kbb_Url
  const offerCodeWC = offerCode === 'wc'
  const offerCodeTC = offerCode === 'tc'
  const isIneligibleYearUnassigned = isIneligibleYear && !isAssigned
  const isCobrandOEM = experienceState?.cobrandingInfo?.isOEMAppraisal || experienceState?.cobrandingInfo?.isOEMTiC
  const landingType = isCobrandOEM ? LandingType.OEM : landingTypeFromUrl
  let landingPageData = {}

  if (process.env.BUILD_STAGE === 'build-html') {
    landingPageData = optimizelyData ?? {}
    if (usingLandingWebComponent) {
      return <LoadingSpinner />
    }
  }

  const {
    argoButtonEnabled,
    vehiclesImageRemoved,
    legalTextMovedToBottom,
    howItWorksStyleChanged,
    videoEnabled,
    titleCopy,
    carInfoSubtitleCopy,
    howItWorksTitleCopy,
    howItWorksSubtitleCopy,
    easyWayCopy,
    videoUrl,
    videoThumbnailUrl,
    infoSteps
  } = landingPageData
 

  const LegalTextWithProps = () => <LegalText {...{ isDesktop, dealerIsDirectToKBBv2, kbbUrl, isLandingPage: true }} />
  return underMaintenance ? (
    <MaintenancePage />
  ) : (
    <StyledDiv id="BodyDivFlex" usingLandingWebComponent={usingLandingWebComponent}>
      {isInactiveDealer ? (
        <InactiveDealer />
      ) : !usingLandingWebComponent ? (
        <>
          <HeaderCopy {...{ isDesktop, isAssigned, isCombined, dealerName, dealerPhone, isUIOffForDR, dealerIsDirectToKBB, dealerIsDirectToKBBv2, offerCode }} heading={titleCopy || 'An Official Offer to Buy Your Car'} />

          <BackgroundDiv isDesktop={isDesktop}>
            <MaxFlexDiv isDesktop={isDesktop}>
              {!props.plateStateVinError && year && make && model && urlState.vin && !backToVin && !isIneligibleYearUnassigned ? (
                <Style
                  {...props}
                  offerCode={offerCode}
                  yearName={year && year.displayName}
                  makeName={(make && (make.displayName || make)) || makeQuery}
                  modelName={(model && (model.displayName || model)) || modelQuery}
                  vin={urlState.vin}
                  submitVinCount={globalState && globalState.submitVinCount}
                  mileageRangeValidated={globalState && globalState.mileageRangeValidated}
                  {...{ isIneligible, backToVin, setBackToVin, urlState, kbbUrl, isDigitalRetail, isCobrandDR, isAssigned, isAdmin, globalState, isIneligibleYear }}
                />
              ) : (
                <>
                  <CarInfo year={year && year.displayName} make={(make && (make.displayName || make)) || makeQuery} model={(model && (model.displayName || model)) || modelQuery} trim={(trim && trim.displayName) || urlState.trimName} vin={urlState.vin} />
                  <StyledDivInfo>{carInfoSubtitleCopy || 'Your License Plate or VIN helps us fill in key details about your vehicle and ensures a more accurate offer.'}</StyledDivInfo>
                  <VehicleInfoTabs
                    {...{
                      ...props,
                      activeTab,
                      onClickTab,
                      states,
                      urlState,
                      isLinksPage,
                      isAdmin,
                      showMakeModelTab,
                      setBackToVin,
                      isIneligible,
                      kbbUrl,
                      experienceState,
                      argoButtonEnabled,
                      isCobrand,
                      isRequireVinPlate
                    }}
                  />
                </>
              )}
            </MaxFlexDiv>
          </BackgroundDiv>
          {legalTextMovedToBottom && (
            <TermsConditionsDiv {...{ vehiclesImageRemoved }}>
              *For limitations, see the <a href="#legal-text">Program Terms and Conditions.</a>
            </TermsConditionsDiv>
          )}

          {!isUIOffForDR && !offerCodeWC && !offerCodeTC && (
            <>
              {!vehiclesImageRemoved && <CarSection {...{ isDesktop, experience, showVechileImageOnLandingPage, dealerIsDirectToKBBv2 }} />}

              {!legalTextMovedToBottom && <LegalTextWithProps />}

              <HowItWorks
                {...{
                  isDesktop,
                  isAssigned,
                  dealerName,
                  dealerIsDirectToKBB,
                  dealerIsDirectToKBBv2,

                  howItWorksStyleChanged,
                  videoEnabled,
                  howItWorksTitleCopy,
                  howItWorksSubtitleCopy,
                  easyWayCopy,
                  videoUrl,
                  videoThumbnailUrl,
                  infoSteps,
                  globalState,
                  updateGlobalState
                }}
              />

              <MobileGap />

              {!dealerIsDirectToKBB && !dealerIsDirectToKBBv2 && <FAQ isDesktop={isDesktop} inline={true} />}
            </>
          )}
          {(isUIOffForDR || offerCodeWC || offerCodeTC) && <MobileLegalText dealerIsDirectToKBBv2={dealerIsDirectToKBBv2} kbbUrl={kbbUrl} />}
        </>
      ) : (
        process.env.BUILD_STAGE !== 'build-html' && (
          <LandingWebComponentWrapper updateGlobalState={updateGlobalState} landingType={landingType} offerCode={offerCode} dealerId={dealerId} isCombined={isCombined} environment={globalState.environment} experienceState={experienceState} {...props} />
        )
      )}
      {legalTextMovedToBottom && (
        <BottomLegalTextContainer id="legal-text">
          <LegalTextWithProps />
        </BottomLegalTextContainer>
      )}
    </StyledDiv>
  )
}

const MobileGap = styled.div`
  @media (max-width: ${breakpoints.lg}px) {
    height: 25px;
  }
`

const TermsConditionsDiv = styled.div`
  ${p => (p.vehiclesImageRemoved ? 'margin-bottom: 60px;' : '')}
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  > a {
    color: #006fe8;
  }
  margin-top: 15px;
  @media (min-width: ${breakpoints.lg}px) {
    margin-top: 20px;
  }
`

const BottomLegalTextContainer = styled.div`
  width: 100%;
  background-color: #f6f6f6;
  > div {
    margin: 16px auto;
  }
  @media (max-width: ${breakpoints.lg}px) {
    font-weight: 600;
    padding: 0 10px;
    > div {
      font-family: Montserrat;
      font-size: 10px;
      line-height: 12px;
    }
  }
`

const StyledDivInfo = styled.div`
  text-align: center;
  font-weight: ${fontWeightRegular};
  font-size: ${fontSize3XSmall};
  font-family: ${fontFamilyOpenSans};
  margin-bottom: 16px;
  width: 100%;
`
const BackgroundDiv = styled.div`
  background-color: ${white};
  border: 1px solid ${grayLight30};
  border-radius: 4px;
  padding: 8px;
  @media (min-width: ${breakpoints.lg}px) {
    padding: 24px 32px;
  }
`
const MaxFlexDiv = styled(FlexDiv)`
  margin-bottom: 8px;
  @media (min-width: ${breakpoints.lg}px) {
    margin-bottom: 0px;
  }
  max-width: 277px;
  min-width: 277px;
  @media (min-width: ${breakpoints.sm}px) {
    max-width: 303px;
    min-width: 303px;
  }
`
const StyledDiv = styled(FlexDiv)`
  color: ${grayDark40};
  background-color: ${white};
  width: 100%;
  ${p => (p.usingLandingWebComponent ? '' : 'padding-top: 12px;')}
`
